import { type FC, Suspense, useEffect } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { useCartAddedNotification } from './useCartAddedNotification.ts';
import { CartAddedNotificationLoader } from './CartAddedNotificationLoader.tsx';
import DropdownLoadingContent from '../Dropdown/DropdownLoadingContent.tsx';
import cartNavStyles from '../CartNav/CartNav-style.scss';
import dropdownStyles from '../Dropdown/Dropdown-style.scss';
import { MESSAGE_BANNER_HEIGHT } from '../Header/Header.tsx';

export const CartAddedNotification: FC = () => {
    const { notification, onClose } = useCartAddedNotification();

    useEffect(() => {
        if (!notification) {
            return;
        }

        const startY = window.scrollY;
        const handleScroll = (): void => {
            if (Math.abs(window.scrollY - startY) < MESSAGE_BANNER_HEIGHT) {
                return;
            }
            onClose();
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        // eslint-disable-next-line consistent-return
        return (): void => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [notification, onClose]);

    if (!notification) {
        return null;
    }

    return (
        <div
            className={classnames(
                dropdownStyles.dropdown,
                cartNavStyles.dropdown,
                dibsCss.opacity100,
                dibsCss.visible
            )}
        >
            <div
                className={classnames(
                    dropdownStyles.bodyWrapper,
                    dropdownStyles.medium,
                    cartNavStyles.dropdownBodyWrapper,
                    dibsCss.zNav,
                    dibsCss.bgWhite,
                    dibsCss.absolute,
                    dibsCss.topFull,
                    dibsCss.right0
                )}
                data-tn="cart-added-notification-desktop"
            >
                <Suspense fallback={<DropdownLoadingContent />}>
                    <CartAddedNotificationLoader
                        notification={notification}
                        onClose={onClose}
                        isMobile={false}
                    />
                </Suspense>
            </div>
        </div>
    );
};
